import { OrderInspectionLog, OrderPicklistMovement, OrderReceipt, PageProps, ProductionOrder } from '../../components/types'
import HeaderDetail from '../../components/HeaderDetail'
import { getDeleteInspectionColumn, OrderInspectionLogColumns, PicklistItemRecordTotalColumn, PicklistItemReturnConfirmColumn } from '../../constants/Column'
import Modal from '../../components/Modal';
import { groupBy as rowGrouper } from 'lodash';
import Comment from '../../components/Comment'
import Badge from '../../components/Badge';
import { BsArrowReturnLeft } from 'react-icons/bs'

import OrderPicklistReducer, { 
  INITIAL_STATE, 
  PicklistAction
} from '../../states/PicklistReducer'
import { 
  postComment,
  getRemotePicklistById,
  getMovementsById,
  pdCompletePicklist,
  pdPostReturnPicklist,
  getOrderReceipts,
  getFGInspectionLogsByOrder,
  pdApproveOrderReceipts,
  updateStatusComment,
  deleteInspectionLog
} from '../../states/PicklistAction'
import { AvgFwtByLot, Department } from '../../models';

import DataGrid, { CalculatedColumn, FormatterProps, RowsChangeData } from 'react-data-grid'
import { useReducer, useEffect, useCallback, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom';
import {
  Tabs,
  TabItem,
} from "@aws-amplify/ui-react";
import { BiCommentDetail } from 'react-icons/bi';
import { MdFactory } from 'react-icons/md';
import { HiMagnifyingGlass } from 'react-icons/hi2';
import { CiReceipt } from 'react-icons/ci';
import { getAverageFillingWeightApi, getOrder, getOrderQueryForRetain, updateFwt } from '../../apis';
import RetainRecord from '../Form/RetainRecord';
import SpinnerLoading from '../../components/SpinnerLoading';

const PicklistCompleteDetail = ({ title, id, username, readOnly, department } : PageProps) => {
  const history = useHistory()
  
  const [ state, dispatch ] = useReducer(
    OrderPicklistReducer, INITIAL_STATE);
  
  const [expandedGroupIds, setExpandedGroupIds] = useState<ReadonlySet<unknown>>(
    () => new Set<unknown>([''])
  );

  const [ productionOrder, setProductionOrder ] = useState<ProductionOrder>()
  const [ fgInspectionLogs, setFgInspectionLogs ] = useState<OrderInspectionLog[]>()
  const [ orderReceipts, setOrderReceipts ] = useState<OrderReceipt[]>()
  const [ refreshFwt, setRefreshFwt ] = useState<boolean>(false)

  useEffect(() => {
    const fetchOrderResults = async (id: string) => {
      const { header, items, comments } = await getRemotePicklistById(id!)
      dispatch({ type: PicklistAction.Inited, payload: { header, items, comments } })

      const mvs = await getMovementsById(id)
      dispatch({ 
        type: PicklistAction.PicklistItemMovementsUpdated, 
        payload: { 
          itemMovements: mvs
        }})
      const bulkBatchNos = mvs.filter(mv => mv.materialType === 'BULK')
        .map(mv => mv.batchLotNo)
      if (bulkBatchNos.length > 0) {
        dispatch({ type: PicklistAction.PicklistBatchNoUpdated, payload: { updateBatchNo: bulkBatchNos.join(',')}})
      }

      const orderForRetain = await getOrder(id, getOrderQueryForRetain)
      setProductionOrder(orderForRetain)

      if (id.startsWith('9')) {
        const fgInspectionLogs = await getFGInspectionLogsByOrder(id)
        setFgInspectionLogs(fgInspectionLogs)
      }

      const orderReceipts =  await getOrderReceipts(id)
			setOrderReceipts(orderReceipts)
    }
    fetchOrderResults(id!)
  }, [ id ])

  useEffect(() => {
    if (state.itemMovements.length > 0) {
      setExpandedGroupIds(new Set(state.itemMovements
        .filter(mv => state.itemMovements.filter(
          mv1 => mv1.materialCode === mv.materialCode).length > 1 || mv.returnGoodQty! > 0 || mv.returnWasteQty! > 0
        )
        .map(itm => itm.materialCode)
        ))
    }
  }, [ state.itemMovements ])

  const openDialog = () => {
    dispatch({ type: PicklistAction.OpenDialog })
  }

  const closeDialog = () => {
    dispatch({ type: PicklistAction.CloseDialog })
  }

  const onApproved = async () => {
    dispatch({ type: PicklistAction.PicklistUpdating })
    const updated = await pdCompletePicklist(state.header!, username!)
    
    const returnMovements = itemMovements
      .filter(mv => (mv.returnGoodQty! > 0 || mv.returnGoodShrinkQty! > 0 || mv.returnWasteQty! > 0) && !mv.returnRefId)
    // note : movement that return qty more than zero and not return before
    if (returnMovements.length > 0) {
      await pdPostReturnPicklist(state.header!,
        returnMovements, username!)
    }

    if (orderReceipts && orderReceipts.length > 0) {
      const approvedReceipts = await pdApproveOrderReceipts(orderReceipts, username!)
      if (approvedReceipts.length !== orderReceipts.length) alert('การอนุมัติ Receipt ไม่สำเร็จ กรุณาตรวจสอบอีกครั้ง')
    }

    dispatch({ type: PicklistAction.PicklistUpdated, payload: { header: updated } })
    history.goBack()
  }

  const onPostComment = useCallback(async (comment: string) => {
    const commentResponse = await postComment(
      state.header?.pk!,
      comment, 
      username!
    )
    dispatch({ type: PicklistAction.PostComment, payload : { comments: [commentResponse] } })
  }, [ state.header?.pk, username ])

  const onActiveComment = useCallback(async (orderId: string, skCommentId: string, active: boolean, version: number) => {
		const updatedComment = await updateStatusComment(orderId, skCommentId, active, version)
    dispatch({ type: PicklistAction.UpdateComment, payload: { comments: [updatedComment] } })
  }, [])
  
  const { header, itemMovements, showConfirmDialog, comments, isSubmitting } = state

  const withDrawItems = new Set(itemMovements.map(itm => itm.materialCode))

  const returnMovements = itemMovements
      .filter(mv => (mv.returnGoodQty! > 0 || mv.returnGoodShrinkQty! > 0 || mv.returnWasteQty! > 0) && !mv.returnRefId)

  const mapBarcodeMovements = useMemo(() => {
    return itemMovements.map(mv => {
      const barcodeItem = state.items.find(itm => itm.materialCode === mv.materialCode)?.barcodePkg
      if (barcodeItem) return { ...mv, barcode: barcodeItem }
      return mv
    })
  }
  , [ itemMovements, state.items ])

  const updateOrderReceiptFromChild = useCallback((updatedReceipt: OrderReceipt) => {
    setOrderReceipts(orderReceipts?.map(log => 
      log.productionOrderId === updatedReceipt.productionOrderId &&
			log.batchLotNo === updatedReceipt.batchLotNo
			? updatedReceipt : log))
  },[ orderReceipts, setOrderReceipts ])

  const updateOrderReceiptsFromChild = useCallback((updatedReceipts: OrderReceipt[]) => {
    setOrderReceipts(updatedReceipts)
  }, [ setOrderReceipts ])

  const onActionRows = async (rows: OrderInspectionLog[], 
    changedInfo: RowsChangeData<OrderInspectionLog>) => {
    const changedRowIdx = changedInfo.indexes[0]
    if (changedRowIdx < 0) return

    const changedRow = rows[changedRowIdx]

    if (changedInfo.column.key === 'delete') {
      const deleted = await deleteInspectionLog(changedRow.id, changedRow._version!);
      setFgInspectionLogs(fgInspectionLogs?.map(log => 
        log.id === deleted.id ? deleted : log))
    }
  };

  const onRefreshFwt = async (
    row: OrderInspectionLog,
    column: CalculatedColumn<OrderInspectionLog>) => {
    if (column.key === 'avgFwtByLots' && row.avgFwtByLots) {
      setRefreshFwt(true)
      const avgFwtByLots = await getAverageFillingWeightApi(
        row.productionOrderId, row.workCenterId)
      const updatedInspectLog = await updateFwt(
        row.id, row._version!, username!, avgFwtByLots)
      setFgInspectionLogs(fgInspectionLogs?.map(log => 
        log.id === updatedInspectLog.id ? updatedInspectLog : log))
      setRefreshFwt(false)
    }
  }

  let fgInspectionColumns = Array.from(OrderInspectionLogColumns)
  fgInspectionColumns.push(getDeleteInspectionColumn(readOnly!, department as Department))

  const activeInspectionLog = useMemo(() => fgInspectionLogs?.filter(log => !log._deleted) || [], [ fgInspectionLogs ])

  return <div className="page-container">
    <HeaderDetail title={`${title} : ${id} ${department}`} header={header} />
    <div className='flex flex-col items-end my-2'>
      {readOnly ? null : <button
        className=' btn-success'
        onClick={openDialog}
        >กดเพื่อปิดเอกสาร / อนุมัติคืน
      </button>}
    </div>
    <Tabs justifyContent="flex-start">
      <TabItem
        title={
          <div className="flex items-center justify-center gap-1">
            <MdFactory />
            รายการใช้ดี/เสีย <Badge variant="info">{`${withDrawItems.size}`}</Badge>
          </div>
        }
      >
        <>
          <DataGrid
            className='my-3'
            style={{ height: "100%", contain: "none" }}
            columns={[...PicklistItemRecordTotalColumn, { 
              key: 'remark', name: 'หมายเหตุ', width: 180,
              formatter: (props: FormatterProps<OrderPicklistMovement>) => {
                if (props.row.returnGoodQty! > 0 || props.row.returnGoodShrinkQty! > 0 || props.row.returnWasteQty! > 0) {
                  const returnRefId = props.row.returnRefId ?
                    props.row.returnRefId.replace(/-/g, '') : ''
                  return <h6 className='flex items-center h-full'>
                    {returnRefId ? <Badge variant=' bg-green-600 text-xs text-white'>
                      <div className='flex items-center justify-center gap-1'>
                        <BsArrowReturnLeft />{`${props.row.returnReasonDescription || ''} (${returnRefId.slice(returnRefId.length - 8)})`}
                      </div>
                    </Badge> : <Badge variant=' text-xs text-green-600 border border-green-600 font-bold'>{props.row.returnReasonDescription || ''}</Badge>}
                  </h6>
                }
                return <></>
              }
            }]}
            rows={mapBarcodeMovements}
            rowKeyGetter={(row) => row.id}
            groupBy={['materialCode']}
            rowGrouper={rowGrouper}
            expandedGroupIds={expandedGroupIds}
            onExpandedGroupIdsChange={setExpandedGroupIds}
            defaultColumnOptions={{ resizable: true }}
            rowClass={row => row.returnGoodQty! > 0 || row.returnGoodShrinkQty! > 0 || row.returnWasteQty! > 0 ? 'bg-green-100':''}
            rowHeight={(arg) => {
              if (arg.type === 'GROUP' && arg.row.childRows[0].barcode) return 55
              return 35
            }}
            headerRowHeight={50}
          />
        </>
      </TabItem>
      <TabItem
        title={
          <div className="flex items-center justify-center gap-1">
            <HiMagnifyingGlass />
            รายการตรวจคุณภาพ <Badge variant='info'>{`${activeInspectionLog.length}`}</Badge>
          </div>
        }
      >
        <DataGrid
          className='my-3'
          style={{ height: "100%", contain: "none" }}
          rows={activeInspectionLog}
          columns={fgInspectionColumns}
          defaultColumnOptions={{ resizable: true }}
          onRowsChange={onActionRows}
          onRowClick={onRefreshFwt}
          rowHeight={row => {
            const rowData = row.row as OrderInspectionLog
            const avgFwtByLots = rowData.avgFwtByLots ? (JSON.parse(rowData.avgFwtByLots) as AvgFwtByLot[]) : []
            if (avgFwtByLots.length === 0) return 35
            const expandedRowHeight = (avgFwtByLots.length * 40) + 15
            return expandedRowHeight
          }}
        />
      </TabItem>
      <TabItem
        title={
          <div className="flex items-center justify-center gap-1">
            <CiReceipt />
            Receipt <Badge variant="info">{`${(orderReceipts || []).length}`}</Badge>
          </div>
        }
      >
        {productionOrder && 
        <RetainRecord
          isFilling={mapBarcodeMovements.filter(mv => mv.materialType === 'BULK').length > 0}
          title='Order Receipt'
          disabledInput={readOnly}
          orderFromParent={productionOrder}
          receiptsFromParent={orderReceipts}
          setReceiptsToParent={updateOrderReceiptsFromChild}
          setReceiptToParent={updateOrderReceiptFromChild}
        />}
      </TabItem>
      <TabItem
        title={
          <div className="flex items-center justify-center gap-1">
            <BiCommentDetail />
            Comments <Badge variant="info">{`${comments.length}`}</Badge>
          </div>
        }
      >
        <Comment comments={comments.sort((a, b) => a.sk.localeCompare(b.sk))} onPost={onPostComment} onActive={onActiveComment} username={username}/>
      </TabItem>
    </Tabs>
    <Modal show={showConfirmDialog} cancelText='ยกเลิก'
      onHide={closeDialog}
      okText="ปิดเอกสาร"
      okTheme='success'
      okAction={onApproved}
      maxWidth='max-w-5xl'
      title={`คุณกำลังปิดเอกสาร / อนุมัติคืน ใบเบิกของ ORDER ${id}`}
      loading={isSubmitting}>
      <div className='space-y-2'>
        <h6>มีรายการคืน WH {returnMovements.length} รายการ</h6>
        <DataGrid
          style={{ height: 'fit-content' }}
          columns={PicklistItemReturnConfirmColumn}
          rows={returnMovements}
          defaultColumnOptions={{ resizable: true }}
          headerRowHeight={50}
        />
        <label className='text-sm '>หมายเหตุ : กรณีมีของคืน ระบบจะส่งเรื่องไปยัง WH เพื่อตรวจรับของคืนจาก PD ต่อไป</label>
        <h6>คุณต้องการปิดเอกสาร / อนุมัติคืนใช่หรือไม่ ?</h6>
      </div>
    </Modal>
    <Modal 
      show={refreshFwt}
      onHide={() => setRefreshFwt(false)}
      title='ดึง Filling Weight ล่าสุด'
      >
      <SpinnerLoading />
    </Modal>
  </div>
}

export default PicklistCompleteDetail

